// react-snap(build 시 정적 프리렌더링)은 헤드리스 브라우저에 이 User-Agent를 심어둔다.
// 이 환경에서는 실제 네트워크(Firebase 등)에 접근할 수 없으므로, 그런 호출을 건너뛰기 위해 사용한다.
export const isReactSnap = () =>
  typeof navigator !== "undefined" &&
  typeof navigator.userAgent === "string" &&
  navigator.userAgent.includes("ReactSnap");

export default isReactSnap;
